import React from 'react';
import ReactDOM, { render } from 'react-dom';

import AppWithStoreAndIntProvider from './components/app/App.component';

if (
  process.env.LOG_A11Y === 'true'
  && process.env.NODE_ENV !== 'production'
) {
  import('react-axe').then(axe => {
    axe.default(React, ReactDOM, 1000);
    render(<AppWithStoreAndIntProvider />, document.getElementById('app'));
  });
} else {
  render(<AppWithStoreAndIntProvider />, document.getElementById('app'));
}
